import { useCallback, useContext } from 'react';
import { AjaxContext, formatListData, AppContext, MerchantContext, UserContext } from 'commons-ui';

import { UserV2 } from 'models/settingsV2.model';
import _filter from 'lodash/filter';
import { bulkPermissionUrlPrefix, RegistrationFilters } from './constants';
import { IFormData } from './submodules/bulkAction/useAction';
import { bulkPermissionUserUrlPrefix, RESOURCES, SETTINGS_V2_ACTION } from '../../../../settingsV2Constant';
import { SERVICE_NAMES } from '../../../../settingsV2Enum';

export interface IUserIdFormData {
	userIdList: string[];
	formData: IFormData;
}

const useService = () => {
	const { app } = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const { merchantName } = useContext(MerchantContext);
	const { user } = useContext(UserContext);

	const getRegisteredUser = useCallback(async (filtersData: RegistrationFilters) => {
		const result = await postData({
			endpoint: `${bulkPermissionUserUrlPrefix}-getUsers`,
			body: {
				managerName: filtersData.managerName,
				department: filtersData.department,
				designation: filtersData.designation,
				roleNameTemp: filtersData.roleNameTemp,
				email: filtersData.email,
				userMerchant: merchantName,
				forwardReqRoute: `/dashboard/${RESOURCES.user}/${SETTINGS_V2_ACTION.getUsers}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName: app.appName
			}
		});
		const listDataModified = _filter(result?.data?.data, (obj) => obj.email !== user?.email);
		const listData: Array<UserV2> = formatListData(listDataModified);
		const listDataLength: number = listData ? listData.length : 0;
		return { rowCount: listDataLength, data: listData };
	}, []);

	const requestAssignPermissions = useCallback((appName: string, data: IUserIdFormData) => {
		return postData({
			endpoint: `${bulkPermissionUrlPrefix}-bulkAssignPermissions`,
			body: {
				userIds: data.userIdList,
				setId: data.formData.permissionsSet,
				permissionIds: data.formData.permissions,
				expiresAfter: data.formData.expiresAfter,
				isMasked: data.formData.isMasked,
				forwardReqRoute: `/dashboard/${RESOURCES.bulkPermission}/${SETTINGS_V2_ACTION.bulkAssignPermissions}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName
			}
		});
	}, []);

	const requestRemovePermissions = useCallback((appName: string, data: IUserIdFormData) => {
		return postData({
			endpoint: `${bulkPermissionUrlPrefix}-bulkRemovePermissions`,
			body: {
				userIds: data.userIdList,
				setId: data.formData.permissionsSet,
				permissionIds: data.formData.permissions,
				forwardReqRoute: `/dashboard/${RESOURCES.bulkPermission}/${SETTINGS_V2_ACTION.bulkRemovePermissions}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		getRegisteredUser,
		requestAssignPermissions,
		requestRemovePermissions
	};
};

export default useService;
